import { render } from "./tab_user.vue?vue&type=template&id=dde38906"
import script from "./tab_user.vue?vue&type=script&lang=js"
export * from "./tab_user.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__